var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tabs" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card" },
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _vm.isBillReview
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("basicData.expressBill"),
                    name: "BillReview",
                    lazy: "",
                  },
                },
                [
                  _vm.activeName === "BillReview"
                    ? _c("div", [_c("BillReview", { ref: "BillReview" })], 1)
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm.isTrunkLine
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("basicData.trunkLineBill"),
                    name: "TrunkLine",
                    lazy: "",
                  },
                },
                [
                  _vm.activeName === "TrunkLine"
                    ? _c("div", [_c("TrunkLine", { ref: "TrunkLine" })], 1)
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }